// extracted by mini-css-extract-plugin
export default {"grid":"grid__SpeciesSearchField__pG6hr","label":"label__SpeciesSearchField__pG6hr","icon":"icon__SpeciesSearchField__pG6hr"};